export default __webpack_public_path__ + "static/media/YOLOv4.cad50d1c.png";